import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { scale } from '@components/frame';
import { getBoxShadowStyle } from '@styles/shadow';
import { SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { BOX_SHADOW_TYPE } from '@components/ncFileVersions/constants';
import { font } from '@styles/fonts';
import i18n from 'i18n-js';
import Svg from '@styles/icons/svg';
import CompareCancelButton from './CompareCancelButton';
import { CompareVersionsBlockProps } from '@components/ncFileVersions/types';

const CompareVersionsBlock: FC<CompareVersionsBlockProps> = ({ C, selectedVersion, onEnterComparisonMode }) => {
  const shadowStyles = getBoxShadowStyle({ type: BOX_SHADOW_TYPE, C });

  return (
    <View
      style={[
        shadowStyles,
        {
          borderRadius: scale(SCREEN_BORDER_RADIUS),
          padding: scale(18),
          backgroundColor: C('Background/Light/Field'),
          alignItems: 'center',
          gap: scale(14),
        },
      ]}
    >
      <Svg icon={C.scheme === 'dark' ? 'compareVersionsDark' : 'compareVersions'} width={scale(120)} height={scale(72)} />
      <Text style={[font.Subheadline, { color: C('Label/Light/Secondary'), textAlign: 'center' }]}>
        {i18n.t('Compare this version with another using a side-by-side view.')}
      </Text>
      <CompareCancelButton testID={TEST_IDS.ncFileVersions.compareButton} C={C} variant="secondary" textOverride={i18n.t('Compare')} onPress={() => onEnterComparisonMode(selectedVersion)} />
    </View>
  );
};

export default CompareVersionsBlock;
